module.exports = __webpack_public_path__ + "img/MarketingResearch.daa99b3d.svg";